/** Platform metinleri. Oyunlar kendi metinlerini kendi klasöründe tutar. */
export const tr = {
  guide: {
    open: 'Nasıl oynanır?',
    back: 'Geri',
    next: 'İleri',
    done: 'Anladım',
    players: 'Oyuncu',
    duration: 'Süre',
  },
  tour: {
    kicker: 'songie',
    title: 'Arkadaşlarla oyun gecesi, tek linkle',
    steps: [
      ['Oyun seç', 'Ana sayfadan bir oyun seç ve “Oda kur”a bas. Her oyunun “Nasıl oynanır?” rehberi var.'],
      ['Arkadaşlarını çağır', 'Odanın 4 harfli kodunu ya da davet linkini paylaş. Gelenler adını yazıp doğrudan odaya girer.'],
      ['Ayarları seç', 'Oda sahibi lobide süreyi, tur sayısını, kategorileri ve takımları seçer; herkes ayarları görür.'],
      ['Oyna', 'Her şey telefondan oynanır. Gizli bilgiler (roller, kartlar, cevaplar) yalnızca görmesi gerekenin ekranına gelir.'],
      ['Menü', 'Sol üstteki menüden ses seviyesini değiştirir, başka bir oyuna geçer ya da profilini düzenlersin.'],
    ] as [string, string][],
    toGames: 'Oyunlara bak',
    gamesTitle: (n: number) => `${n} oyun`,
    gamesLead: 'Birine dokun, nasıl oynandığını anlatalım.',
    start: 'Başla',
    replay: 'Oyunları tanı',
  },
  shell: {
    open: 'Menüyü aç',
    close: 'Menüyü kapat',
    subtitle: 'Oyunlar ve ayarlar',
    volume: 'Ses',
    games: 'Oyun seç',
    moreSoon: 'Yeni oyunlar bu listeye eklenecek.',
    profile: 'Profili düzenle',
  },
  welcome: {
    title: 'Adın ne?',
    sub: 'Arkadaşların seni bu adla görecek.',
    note: 'Şifre yok; profilin bu tarayıcıda saklanır.',
    tagline: 'Arkadaşlarla oyun gecesi, tek linkle',
    nick: 'Takma ad',
    nickPlaceholder: 'Takma adını yaz',
    color: 'Renk',
    save: 'Devam et',
    saving: 'Kaydediliyor…',
  },
  home: {
    hello: (nick: string) => `Selam, ${nick}!`,
    helloSub: 'Bu akşam ne oynuyoruz?',
    heroTitle: 'Arkadaşlarını topla, oyun başlasın!',
    heroLead: 'Odanı kur, linki gruba at. Herkes kendi telefonundan katılır.',
    createRoom: 'Oda Oluştur',
    badgesLabel: 'Songie hakkında',
    badges: ['Üyelik yok', 'İndirme yok', '%100 Türkçe'],
    joinSticker: '4 harf yeter',
    joinTitle: 'Odaya katıl',
    join: 'Katıl',
    joining: 'Katılıyor…',
    codeLabel: 'Oda kodu',
    codeLength: 'Oda kodu 4 harften oluşur.',
    codePlaceholder: 'ABCD',
    joinHint: 'Arkadaşının paylaştığı 4 harfli kodu yaz.',
    featureTag: 'UZUN SOLUKLU MACERA',
    featureName: 'Dedektif Masası',
    featureLead: 'İstanbul’dan Mardin’e 15 polisiye vaka. Ekibinle çöz, kaldığın yerden devam et.',
    create: 'Oda kur',
    solo: 'Tek başına oyna',
    games: 'Oyunlar',
    filterLabel: 'Kategori filtresi',
    stepsTitle: '3 adımda oyundasın',
    steps: [
      ['Odanı kur', 'Tek dokunuş, kayıt yok.'],
      ['Linki paylaş', 'Gruba at ya da 4 harfli kodu sesli söyle.'],
      ['Oyunu seç, başla', 'Kurallar her oyunda bir dokunuş uzakta.'],
    ] as [string, string][],
    footer: 'songie · arkadaşlarınla eğlencenin yeni adresi',
    backToRoom: (code: string) => `${code} odasına dön`,
  },
  picker: {
    createTitle: 'Hangi oyunu oynuyoruz?',
    changeTitle: 'Oyunu değiştir',
    current: 'Şu an seçili',
  },
  room: {
    copyLink: 'Davet linkini kopyala',
    copyDone: 'Kopyalandı!',
    share: 'Paylaş',
    shareText: (game: string) => `${game} oynuyoruz, gel!`,
    selectedGame: 'Seçilen oyun',
    change: 'Değiştir',
    readyCount: (n: number) => `${n} kişi hazır`,
    waiting: 'Arkadaşların bekleniyor… linki gruba at!',
    settings: 'Oyun ayarları',
    gameOver: 'Oyun bitti',
    winner: (nick: string) => `${nick} kazandı!`,
    draw: 'Berabere!',
    points: 'puan',
    rematch: 'Rövanş!',
    otherGame: 'Başka oyun seç',
    saved: 'Skorlar kaydedildi',
    backToLobby: 'Lobiye dönülüyor…',
    toLobby: 'Lobiye dön',
    copied: 'Link kopyalandı. Arkadaşlarına gönder.',
    codeLabel: 'Oda kodu',
    players: 'Oyuncular',
    host: 'oda sahibi',
    you: 'sen',
    offline: 'bağlantı yok',
    ready: 'hazır',
    kick: 'Çıkar',
    start: 'Oyunu başlat',
    starting: 'Şarkılar hazırlanıyor…',
    needPlayers: (n: number) => `Başlamak için en az ${n} kişi gerekiyor.`,
    imReady: 'Hazırım',
    notReady: 'Hazır değilim',
    waitHost: 'Oda sahibi oyunu başlatınca oyun açılacak.',
    leave: 'Odadan çık',
    lastGame: 'Son oyun',
    chat: 'Sohbet',
    chatPlaceholder: 'Mesaj yaz',
    send: 'Gönder',
    chatEmpty: 'Henüz mesaj yok.',
    notFound: 'Bu kodla açık bir oda yok.',
    home: 'Ana sayfaya dön',
    connecting: 'Odaya bağlanıyor…',
    end: 'Oyunu bitir',
    endConfirm: 'Oyun bitsin mi? Skorlar kaydedilir.',
    reconnecting: 'Bağlantı koptu, yeniden bağlanıyor…',
  },
  account: {
    or: 'ya da',
    continue: 'Google ile devam et',
    continueHint: 'Başka cihazda açtığın profilin geri gelir.',
    sticker: 'Her cihazda',
    linkTitle: 'Profilini Google’a bağla',
    linkLead: 'Profilin ve istatistiklerin telefonda da bilgisayarda da aynı kalsın.',
    link: 'Google ile bağla',
    linked: 'Google’a bağlı',
    signOut: 'Çıkış yap',
    signingIn: 'Google açılıyor…',
    failed: 'Google ile giriş yapılamadı. Tekrar dene.',
    linkedToast: 'Profilin Google hesabına bağlandı.',
  },
  profile: {
    title: 'Profil',
    games: 'Oyun',
    wins: 'Galibiyet',
    best: 'En yüksek skor',
    streak: 'En uzun seri',
    save: 'Kaydet',
    saved: 'Profil kaydedildi.',
  },
  legal: {
    updated: 'Son güncelleme: 25 Ekim 2026',
    contactEmail: 'info@monolithyazilim.com',
    toChoices: 'Gizlilik tercihlerine git',
    toPolicy: 'Gizlilik politikasını oku',
    home: 'Oyunlara dön',
    privacy: {
      title: 'Gizlilik Politikası',
      lead: 'Songie, İtiraf Köşesi, Casebook ve We Knows uygulamaları ile bu web sitesi Monolith Yazılım tarafından sunulur. Bu sayfa hangi verileri neden tuttuğumuzu ve onları nasıl silebileceğini anlatır.',
      sections: [
        {
          title: 'Kısaca',
          items: [
            'Reklam göstermiyoruz, seni izlemiyoruz, verini satmıyoruz.',
            'Analitik, reklam ya da izleme SDK’sı kullanmıyoruz; App Store’un tanımıyla seni uygulamalar ve siteler arasında takip etmiyoruz.',
            'Oynamak için yalnızca bir takma ad yeter. Google ya da Apple ile giriş isteğe bağlıdır.',
            'Hesabını ve verilerini istediğin an silebilirsin.',
          ],
        },
        {
          title: 'Topladığımız veriler',
          items: [
            'Profil: seçtiğin takma ad ve avatar (şekil ve renk).',
            'Oturum anahtarı: cihazında saklanır; sunucuda yalnızca tek yönlü özeti (hash) tutulur.',
            'Google ya da Apple ile giriş yaparsan: e-posta adresin, hesabın kimlik numarası ve giriş sağlayıcısı. Girişi Google Firebase Authentication doğrular; şifreni hiçbir zaman görmeyiz.',
            'Oyun sonuçları: oynadığın oyun, puanın, sıran, odadaki oyuncu sayısı, oda kodu ve tarih. Profilindeki istatistikler ve rekorlar buradan hesaplanır.',
            'Oyun sırasında yazdıkların ve seçtiklerin (sohbet, itiraflar, cevaplar, oylar): yalnızca oyun sürerken sunucunun belleğinde tutulur, oda kapanınca silinir. Casebook (dedektif) vaka dosyaları ve ekibin notları, dosyaya sonra devam edebilesiniz diye saklanır.',
            'Teknik kayıtlar: bağlantı ve güvenlik için IP adresi ve istek kayıtları sunucu ve Cloudflare tarafından kısa süreli tutulur.',
          ],
        },
        {
          title: 'Toplamadıklarımız',
          items: [
            'Konum, rehber, fotoğraflar, mikrofon ya da kamera verisi.',
            'Reklam kimliği (IDFA) ya da cihaz parmak izi.',
            'Ödeme bilgisi: uygulamalar ücretsizdir.',
          ],
        },
        {
          title: 'Verileri neden kullanıyoruz',
          items: [
            'Seni odada arkadaşlarına adınla göstermek ve oyunu oynatmak.',
            'Profilini cihazlar arasında taşımak (Google ya da Apple ile giriş yaptıysan).',
            'Skorları, rekorları ve istatistikleri göstermek.',
            'Hizmeti güvenli ve çalışır tutmak.',
          ],
        },
        {
          title: 'Paylaştığımız hizmet sağlayıcılar',
          items: [
            'Google Firebase Authentication ve Sign in with Apple: yalnızca giriş yaptığında, kimliğini doğrulamak için.',
            'Cloudflare: siteye ve sunucuya güvenli bağlantı için.',
            'Deezer: Songie’deki şarkı önizlemeleri sunucumuz üzerinden Deezer’dan alınır; Deezer’a senin hakkında veri gönderilmez.',
          ],
          note: 'Verini bunların dışında kimseyle paylaşmayız, satmayız ve reklam için kullanmayız.',
        },
        {
          title: 'Ne kadar saklıyoruz',
          items: [
            'Profil, oyun sonuçları ve hesap bağlantısı: sen silene kadar.',
            'Oyun içi yazışmalar ve cevaplar: oda kapanana kadar.',
            'Casebook vaka dosyaları: dosyanın son üyesi hesabını silene kadar.',
          ],
        },
        {
          title: 'Hakların',
          paras: [
            'KVKK ve GDPR kapsamında verine erişme, düzeltme, silme ve işlenmesine itiraz etme hakkın var. Takma adını ve avatarını Profil sayfasından değiştirebilir, hesabını ve bütün verilerini uygulamadaki Profil sayfasından ya da Gizlilik tercihleri sayfasından silebilirsin. Diğer talepler için bize e-posta gönder.',
          ],
        },
        {
          title: 'Çocuklar',
          paras: ['Uygulamalar 13 yaşından küçük çocuklara yönelik değildir ve onlardan bilerek veri toplamayız. İtiraf Köşesi’ndeki bazı kart paketleri yalnızca yetişkinler içindir.'],
        },
        {
          title: 'Değişiklikler',
          paras: ['Bu politikayı güncellersek tarihi bu sayfada değiştiririz. Önemli değişiklikleri uygulamalarda da duyururuz.'],
        },
      ] as { title: string; items?: string[]; paras?: string[]; note?: string }[],
      contact: 'İletişim',
      contactLead: 'Gizlilikle ilgili her soru ve talep için:',
      english: 'In English',
      englishText:
        'Songie, İtiraf Köşesi, Casebook and We Knows (by Monolith Yazılım) show no ads, use no analytics or tracking SDKs and do not track you across apps or websites. We store a nickname and avatar, a hashed session token, your game results and, only if you sign in with Google or Apple, your email address and account ID (verified by Firebase Authentication). In-game messages live in server memory until the room closes; Casebook case files and notes are kept so a team can resume. You can delete your account and all its data at any time on the Privacy Choices page or by emailing us.',
    },
    choices: {
      title: 'Gizlilik Tercihleri',
      lead: 'Verilerin üzerinde söz senin. Buradan hesabını ve bütün verilerini silebilir, bu cihazdaki oturumu kapatabilirsin.',
      tracking: 'Reklam ve izleme',
      trackingText: 'Reklam göstermiyor, izleme yapmıyor ve analitik kullanmıyoruz. Kapatman gereken bir şey yok.',
      account: 'Hesabın',
      noProfile: 'Bu tarayıcıda bir profil yok. Uygulamada oynadıysan hesabını uygulamanın Profil sayfasındaki “Hesabımı sil” ile silebilirsin. Google ile giriş yaptıysan aynı hesapla burada giriş yapıp da silebilirsin.',
      signedInAs: (nick: string) => `Bu tarayıcıda “${nick}” profiliyle oturum açık.`,
      linked: (email: string) => `Bağlı hesap: ${email}`,
      anonymous: 'Profilin bir Google ya da Apple hesabına bağlı değil; yalnızca bu tarayıcıda saklanıyor.',
      deleteTitle: 'Hesabımı ve verilerimi sil',
      deleteText: 'Profilin, oyun sonuçların, istatistiklerin, hesap bağlantın ve oturum anahtarların kalıcı olarak silinir; Casebook dosyalarından çıkarılırsın. Bu işlem geri alınamaz.',
      deleteBtn: 'Hesabımı sil',
      confirmTitle: 'Emin misin?',
      confirmText: 'Bütün verilerin kalıcı olarak silinecek. Aynı Google ya da Apple hesabıyla yeniden girersen sıfırdan yeni bir profil açılır.',
      confirmBtn: 'Evet, kalıcı olarak sil',
      cancel: 'Vazgeç',
      deleting: 'Siliniyor…',
      deleted: 'Hesabın ve bütün verilerin silindi.',
      failed: 'Silinemedi. Tekrar dene ya da bize e-posta gönder.',
      signOut: 'Bu cihazda oturumu kapat',
      apps: 'Mobil uygulamalarda',
      appsText: 'Songie, İtiraf Köşesi, Casebook ve We Knows’ta Profil sayfasının en altındaki “Hesabımı sil” düğmesi hesabını ve bütün verilerini siler; Apple ile giriş yaptıysan Apple bağlantın da iptal edilir. Uygulamaya erişemiyorsan bize e-posta gönder; takma adını ve hangi uygulamayı kullandığını yazman yeterli.',
      email: 'E-posta ile talep',
      emailText: 'Erişim, düzeltme ya da silme taleplerini e-postayla da iletebilirsin; en geç 30 gün içinde yanıtlarız.',
    },
  },
};
